import API from './API'
const route = 'shift-area/'
import Record_behavir from './FirebaseAPI/RecordBill'
import Cookies from 'js-cookie'

var record = new Record_behavir()
var Shift_area = (function () {
  var time_option = {
    '00:00:00': '0',
    '01:00:00': '1',
    '02:00:00': '2',
    '03:00:00': '3',
    '04:00:00': '4',
    '05:00:00': '5',
    '06:00:00': '6',
    '07:00:00': '7',
    '08:00:00': '8',
    '09:00:00': '9',
    '10:00:00': '10',
    '11:00:00': '11',
    '12:00:00': '12',
    '13:00:00': '13',
    '14:00:00': '14',
    '15:00:00': '15',
    '16:00:00': '16',
    '17:00:00': '17',
    '18:00:00': '18',
    '19:00:00': '19',
    '20:00:00': '20',
    '21:00:00': '21',
    '22:00:00': '22',
    '23:00:00': '23',
    '24:00:00': '24',
  }
  function shift_area() {
    // this.api = new API()
  }
  shift_area.prototype.getTimeOptions = function () {
    return time_option
  }
  shift_area.prototype.getDetail = function (id) {
    return API.get(`${route}${id}`)
  }
  shift_area.prototype.getArea = function () {
    return API.get(`${route}area`)
  }
  shift_area.prototype.create = async function (data) {
    // return API.post(route,data)
    return await API.post(route, data)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '排班區域'
        recordInfo.event = '新增排班區'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = res.id
        recordInfo.note = { name: data.name }
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.message,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  shift_area.prototype.delete = function (id) {
    return API.delete(`${route}delete/?id=${id}`)
      .then((res) => {
        if (res.success) {
          let recordInfo = {}
          recordInfo.type = '排班區域'
          recordInfo.event = '移除排班區'
          recordInfo.code = Cookies.get('GladTeamCode')
          recordInfo.id = id
          recordInfo.note = { name: '' }
          recordInfo.user_name = Cookies.get('GladName')
          recordInfo.user_id = ''
          record.postRecord(recordInfo)
          return { success: true }
        } else {
          return { success: false }
        }
      })
      .catch((e) => {
        console.error(e)
        return { success: false }
      })
  }
  shift_area.prototype.update = async function (id, task, data) {
    return await API.put(`${route}update/?id=${id}&task=${task}`, data)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '排班區域'
        recordInfo.event = '更新排班區'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = id
        recordInfo.note = { name: data.name }
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.message,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
    // return API.put(`${route}update/?id=${id}&task=${task}`,data)
  }

  return shift_area
})()

export default Shift_area



// WEBPACK FOOTER //
// ./src/assets/js/libs/Shift_area.js